export type UniqueValueSelector<T> = (input: T) => any;

export class ArrayHelper {
  public static distinctValues<T>(
    array: T[],
    valueSelector: UniqueValueSelector<T> = value => value
  ): T[] {
    return array.filter(
      (value, index, result) =>
        result.indexOf(result.find(current => valueSelector(current) === valueSelector(value))) ===
        index
    );
  }
}

export function replaceOrAppend<T>(
  array: T[],
  newItem: T,
  predicate: (item: T) => boolean,
  appendIfNotFound: boolean = true
): T[] {
  const index = array.findIndex(predicate);
  if (index !== -1) {
    const newArray = [...array];
    newArray[index] = newItem;
    return newArray;
  } else if (appendIfNotFound) {
    return [...array, newItem];
  } else {
    return array;
  }
}
export function appendOrDelete<T>(
  array: T[],
  item: T,
  isEqual: (a: T, b: T) => boolean = (a, b) => a === b
): T[] {
  const index = array.findIndex(x => isEqual(x, item));

  if (index === -1) {
    return [...array, item];
  } else {
    return array.filter((_, i) => i !== index);
  }
}
